import { ref, onUnmounted, onMounted } from "vue";
import { createRequest, createRequestWithFormData } from "@/helpers/utilities";

// ===== Helpers =====
export const formatValue = (value) => {
  switch (value) {
    case null:
      return "";
    case true:
      return 1;
    case false:
      return 0;
    default:
      return value;
  }
};

// ===== Module ID tracker =====
export const useModuleId = (callback, event_name = "crud_change_id") => {
  const moduleId = ref(0);

  const updateCurrentId = (e) => {
    moduleId.value =
      event_name === "custom_form" ? e.detail.form_id : Number(e.detail.form_id);
    callback && callback();
  };

  document.addEventListener(event_name, updateCurrentId);
  onUnmounted(() => document.removeEventListener(event_name, updateCurrentId));

  return moduleId;
};

// ===== Offcanvas / Modal helpers =====
export const useOnOffcanvasShow = (elemName, callback) => {
  onMounted(() => {
    const el = document.getElementById(elemName);
    el?.addEventListener("shown.bs.offcanvas", () => callback && callback());
  });
};

export const useOnOffcanvasHide = (elemName, callback) => {
  onMounted(() => {
    const el = document.getElementById(elemName);
    el?.addEventListener("hidden.bs.offcanvas", () => callback && callback());
  });
};

export const useOnModalHide = (elemName, callback) => {
  onMounted(() => {
    const el = document.getElementById(elemName);
    el?.addEventListener("hide.bs.modal", () => callback && callback());
  });
};

// ===== CRUD Requests =====
export const useRequest = () => {
  const getRequest = async ({ url, id }) => {
    const endpoint = typeof url === "function" ? url(id) : url;
    return createRequest(endpoint);
  };

  const listingRequest = async ({ url, data = {} }) => {
    const endpoint = typeof url === "function" ? url(data) : url;
    return createRequest(endpoint);
  };

  const storeRequest = async ({ url, body, method = "POST", type }) => {
    const endpoint = typeof url === "function" ? url() : url;

    if (type === "file") {
      const formData = new FormData();
      Object.keys(body).forEach((k) => formData.append(k, formatValue(body[k])));
      if (method === "PUT") formData.append("_method", "PUT");

      return createRequestWithFormData(
        endpoint,
        { Accept: "application/json" },
        formData
      );
    }

    return createRequest(endpoint, { method }, body);
  };

  const updateRequest = async ({ url, id, body, method = "PUT", type }) => {
    const endpoint = typeof url === "function" ? url(id) : `${url}/${id}`;

    if (type === "file") {
      const formData = new FormData();
      Object.keys(body).forEach((k) => formData.append(k, formatValue(body[k])));
      return createRequestWithFormData(endpoint, { method }, formData);
    }

    return createRequest(endpoint, { method }, body);
  };

  // ✅ DELETE Request (زيدناها باش clearcache يخدم)
  const deleteRequest = async ({ url, id = null, data = {} }) => {
    const endpoint =
      typeof url === "function"
        ? url(id)
        : id
          ? `${url}/${id}`
          : url;

    return createRequest(endpoint, { method: "DELETE" }, data);
  };

  return {
    getRequest,
    listingRequest,
    storeRequest,
    updateRequest,
    deleteRequest,
  };
};
